import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { refreshUserSubscription } from "util/surveyStripe";

export default function useSurveyCheckoutReturn({ user, onRefresh }) {
  const location = useLocation();
  const { t } = useTranslation();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const params = new URLSearchParams(location.search);
    const result = params.get("survey_purchase");
    if (!result) return;
    handled.current = true;

    if (result === "success") {
      message.success(
        t("surveyManagement.checkout_success", "Your subscription is updating."),
      );
      if (user?.uid) {
        refreshUserSubscription(user.uid).finally(() => {
          if (onRefresh) onRefresh();
        });
      } else if (onRefresh) {
        onRefresh();
      }
    }

    params.delete("survey_purchase");
    const nextSearch = params.toString();
    const nextUrl = `${location.pathname}${nextSearch ? `?${nextSearch}` : ""}`;
    window.history.replaceState({}, "", nextUrl);
  }, [location.pathname, location.search, onRefresh, t, user?.uid]);
}
